export const useHelpers = () => {

    const formatMoney = (value) => {
        const num = typeof value === 'string'
            ? parseFloat(value.replace(/,/g, ''))
            : Number(value);

        if (isNaN(num)) return '0.00';

        return num.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    }

    return Object.freeze({
        formatMoney
    })
}
